<h1 class="page__title my-5 h2" translate>smsadv_create_title</h1>
<div class="mb-5" [formGroup]="selectionForm">
  <!-- gender section -->
  <h3 class="mb-3" translate>smsadv_create_gender</h3>
  <div class="form-check-inline">
    <!-- gender all  -->
    <label class="radio-custom">
      <input type="radio" name="gender" [formControl]="genderFC" value="ALL" />
      <span class="radio-custom__radio"></span>
      <span class="radio-custom__label" translate>smsadv_gender_all</span>
    </label>
    <!-- gender M  -->
    <label class="radio-custom">
      <input type="radio" name="gender" [formControl]="genderFC" value="M" />
      <span class="radio-custom__radio"></span>
      <span class="radio-custom__label" translate>smsadv_gender_male</span>
    </label>
    <!-- gender F  -->
    <label class="radio-custom">
      <input type="radio" name="gender" [formControl]="genderFC" value="F" />
      <span class="radio-custom__radio"></span>
      <span class="radio-custom__label" translate>smsadv_gender_female</span>
    </label>
  </div>
  <!-- age  -->
  <h3 class="my-4" translate>smsadv_create_age</h3>
  <div class="d-flex align-items-center">
    <div class="custom-slider mx-3 w-100">
      <ngx-slider [(highValue)]="maxValueSliderDemograph" [options]="rangeSliderDemoGraph" [formControl]="ageRangesFC"></ngx-slider>
    </div>
  </div>
  <!-- Area Geographic -->
  <h3 class="my-4" translate>smsadv_create_area</h3>
  <div>
    <div class="form-check-inline encoding-selection">
      <label class="radio-custom">
        <input type="radio" checked="radioAreaGeo" value="" />
        <span class="radio-custom__radio"></span>
      </label>
      <span class="area-choose-label" translate>{{ 'smsadv_create_area_choose' }}</span>
    </div>
    <div formGroupName="recipientCriteria" class="collapsable" [@toggleHeight]="isShowAreaGeographic ? 'show' : 'hide'">
      <span translate>smsadv_create_area_choose_info</span>
      <!-- Region -->
      <div>
        <label class="my-3" translate>smsadv_create_area_choose_region</label>
        <div class="p-0 col-sm-6">
          <ng-select
            placeholder="{{ 'smsadv_create_area_choose_region_placeholder' | translate }}"
            class="form-control"
            multiple="true"
            formControlName="regions"
            bindLabel="name"
            [searchable]="true"
            [items]="this.selectRegions"
            (change)="changeRegions($event)"
          >
          </ng-select>
        </div>

        <!-- Province -->
        <label class="my-3" translate>smsadv_create_area_choose_province</label>
        <div class="p-0 col-sm-6">
          <ng-select
            bindLabel="extendedName"
            class="form-control"
            multiple="true"
            formControlName="provinces"
            placeholder="{{ 'smsadv_create_area_choose_province_placeholder' | translate }}"
            [searchable]="true"
            [items]="this.selectProvinces"
            (change)="changeProvinces($event)"
          >
          </ng-select>
          <div *ngIf="isShowWarnMsgProvinces" class="invalid-feedback d-block">
            {{ 'smsadv_create_province_already_inside' | translate }}
          </div>
        </div>
        <!-- ZipCodes -->
        <label class="my-3" translate>smsadv_create_area_choose_zipcode</label>
        <div class="p-0 col-sm-6">
          <ng-select
            bindLabel="zipCode"
            class="form-control"
            multiple="true"
            formControlName="zipCodes"
            placeholder="{{ 'smsadv_create_area_choose_zipcode_placeholder' | translate }}"
            [searchable]="true"
            [items]="this.selectZipCodes"
          >
          </ng-select>
          <div *ngIf="isShowWarnMsgZipCodes" class="invalid-feedback d-block">
            {{ 'smsadv_create_zip_already_inside' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Estimated recipients -->
  <div class="my-5">
    <div class="d-flex">
      <h3 class="my-3" translate>smsadv_create_count_recipients</h3>
      <div
        class="tooltip-custom border rounded-circle border-1"
        #tooltip="matTooltip"
        matTooltipPosition="above"
        matTooltipClass="tooltip-class"
        matTooltip="{{ 'smsadv_create_bottom_note' | translate }}"
      >
        <p>?</p>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <span>
        <img class="icon-recipient-custom" src="assets/images/icons/icon-recipients.svg" />
      </span>
      <span *ngIf="isShowCountRecipient" class="recip-estimate">{{ recipientEstimate }}</span>
      <span *ngIf="!isShowCountRecipient" class="recip-estimate">{{ 'smsadv_create_count_recipients_null' | translate }}</span>
    </div>
  </div>
  <!-- Limit Recipient -->
  <div class="my-5">
    <h3 class="my-3" translate>smsadv_create_limit_recipients</h3>
    <div class="d-flex flex-column">
      <div class="form-check-inline encoding-selection">
        <label class="radio-custom">
          <input type="radio" name="limitRecipientRadio" value="0" [formControl]="limitRecipientFC" />
          <span class="radio-custom__radio"></span>
        </label>
        <span class="area-choose-label" translate>smsadv_create_nolimit_recipients</span>
      </div>
      <div class="my-3 form-check-inline encoding-selection">
        <label class="radio-custom">
          <input type="radio" name="limitRecipientRadio" value="1" [formControl]="limitRecipientFC" />
          <span class="radio-custom__radio"></span>
        </label>
        <span class="area-choose-label" translate>smsadv_create_limit_number_recipients</span>
      </div>
      <div class="collapsable" [@toggleHeight]="isShowLimitRecipient ? 'show' : 'hide'">
        <input
          type="text"
          class="form-control col-sm-2"
          name="limitRecipientsText"
          formControlName="limitRecipients"
          placeholder="{{ 'smsadv_create_limit_recipients_limit_placeholder' | translate }}"
        />
        <wsb-validation-error-msg [fc]="limitRecipients"></wsb-validation-error-msg>
      </div>
    </div>
  </div>
</div>
